import { FIELD_KEY } from '../../../../utils/constants'

/**
 * Defines custom sections for grouping fields together
 * Fields within each section are displayed in the order specified by `fieldsKeyInSection`
 */
export const customSections = [
    {
        sectionKey: 'overhang_size',
        sectionName: 'Overhang Size',
        fieldsKeyInSection: [FIELD_KEY.GABLE_WIDTH, FIELD_KEY.EAVE_WIDTH],
    },
    {
        sectionKey: 'soffit',
        sectionName: 'Soffit',
        fieldsKeyInSection: [FIELD_KEY.EXPOSED_SOFFIT, FIELD_KEY.SOFFIT_TYPE],
    },
]
